const getStyles = theme => ({
    root: {
        width: '100%',
        '@media print': {
            display: 'none',
        },
    },
    grow: {
        flexGrow: 1,
    },
    button: {
        margin: theme.spacing(1),
    },
    rightIcon: {
        marginLeft: 2,
    },
    profileMenuWrapper: {
        marginLeft: theme.spacing(1),
    },
    progress: {
        height: 2,
        marginTop: -2,
    },
    drawer: {
        width: 240,
    },
    drawerPaper: {
        width: 240,
    },
    drawerSubList: {
        backgroundColor: theme.palette.grey[200],
    },
    drawerSubListItem: {
        paddingLeft: theme.spacing(5),
    },
    activeLink: {
        pointerEvents: 'none',
    },
    activeButton: {
        margin: theme.spacing(1),
        borderBottom: '3px solid #007cfc',
        borderRadius: 0,
        marginBottom: -6,
        paddingBottom: 18,
    },
});

export default getStyles;
